module.exports = __webpack_public_path__ + "nc_static/media/register-iot.893fb7a3.svg";